import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'listLimit' })
export class listLimitPipe implements PipeTransform {
    transform(arr: any[], limit: number) {
        if (!arr || !arr.length || !limit || arr.length <= limit) { return arr; }

        const copy = [...arr];
        copy.length = limit;

        return copy;
    }
}
